import React from 'react';
import { Link } from 'react-router-dom';
import { BenefitCard } from '../../components/BenefitCard';
import { Shield, Target, Zap, Sprout, Heart, Users, Trophy } from 'lucide-react';
export function HomeBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1644">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1645">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1646">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1647">
            More Than Kicks - Life Skills That Carry Off the Mat
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1648">
          <BenefitCard icon={Shield} title="Confidence" description="Students learn to stand tall, speak clearly, and believe in their ability to overcome challenges." data-id="element-1649" />
          <BenefitCard icon={Target} title="Focus" description="Structured drills improve attention span and concentration, which carries over to school and work." data-id="element-1650" />
          <BenefitCard icon={Zap} title="Discipline" description="We teach the importance of doing the right thing, even when it's hard, building strong character." data-id="element-1651" />
          <BenefitCard icon={Sprout} title="Resilience" description="Students learn to push through challenges, bounce back from setbacks, and keep going when training gets tough." data-id="element-1652" />
          <BenefitCard icon={Heart} title="Fitness" description="Dynamic, full-body workouts that improve coordination, strength, flexibility, and cardiovascular health." data-id="element-1653" />
          <BenefitCard icon={Users} title="Teamwork" description="A supportive environment where students encourage each other and build lasting friendships." data-id="element-1654" />
          <BenefitCard icon={Trophy} title="Goal Setting" description="The belt system provides clear, achievable goals that teach the value of long-term dedication." data-id="element-1655" />
        </div>

        <div className="mt-16 flex justify-center" data-id="element-1656">
          <Link to="/SignMeUp" className="btn-primary" data-id="element-1657">
            Start With a Trial Class
          </Link>
        </div>
      </div>
    </section>;
}